import {
  container,
  containerWide,
  title,
  cardTitle,
  description,
  mlAuto,
  mrAuto,
  section,
  sectionDark,
  coloredShadow,
  blackColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from "/styles/jss/nextjs-material-kit-pro.js";

const teamsSection = {
  container,
  containerWide,
  title,
  mlAuto,
  mrAuto,
  cardTitle,
  coloredShadow,
  description,
  descriptionWhite: {
    ...description,
  },
  textCenter: {
    textAlign: "center",
  },
  team: {
    padding: "80px 0",
    "& h5$description,& h5$descriptionWhite": {
      marginBottom: "80px",
    },
  },
  section: {
    ...sectionDark,
    ...section,
    position: "relative",
    "& $title": {
      color: whiteColor,
    },
    "& $descriptionWhite": {
      color: "rgba(" + hexToRgb(whiteColor) + ", 0.76)",
    },
    "& $container": {
      zIndex: "2",
      position: "relative",
    },
    "&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''",
      backgroundColor: "rgba(" + hexToRgb(blackColor) + ", 0.7)",
    },
  },

  sectionLight: {
    ...sectionDark,
    ...section,
    position: "relative",
    "& $title": {
      color: whiteColor,
    },
    "& $descriptionWhite": {
      color: "rgba(" + hexToRgb(whiteColor) + ", 0.76)",
    },
    "& $container": {
      zIndex: "2",
      position: "relative",
    },
    "&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''",
      //backgroundColor: "rgba(" + hexToRgb(blackColor) + ", 0.7)",
    },
  },
  justifyContent: {
    WebkitBoxPack: "center !important",
    MsFlexPack: "center !important",
    justifyContent: "center !important",
  },
  cardCategory: {
    marginTop: "10px",
  },
  btn: {
    marginTop: "0 !important",
  },
  card3: {
    textAlign: "left",
  },
  card5: {
    textAlign: "left",
    "& $cardTitle": {
      color: whiteColor,
    },
    "& $description": {
      color: whiteColor,
    },
  },
  container2: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
  },
  linkColumns: {
    display: "flex",
    justifyContent: "space-between",
  },
  ul: {
    listStyle: "bullet",
  },
  breadcrumb: {
    "& a": {
      marginRight: "5px",
      color: "blue",
      textDecoration: "none",
    },
    "& span": {
      marginLeft: "5px",
    },
  },
  separator: {
    marginLeft: "10px", // or your desired spacing
    marginRight: "10px",
  },
  section2: {
    backgroundPosition: "50%",
    backgroundSize: "cover",
    padding: "50px 0 50px 0", // top and bottom padding for desktop
    "@media (max-width: 768px)": {
      // for devices with width up to 768px (typical breakpoint for tablets and mobiles)
      padding: "50px 0 40px 0", // top and bottom padding for mobile/tablet views
    },
    "& p": {
      fontSize: "1.188rem",
      lineHeight: "1.5em",
      color: grayColor[15],
      marginBottom: "300px",
    },
  },
};

export default teamsSection;
